import "../components/Styles/PropertyRegistration.css";

function PropertyRegistration() {

  return (

    <div className="registration-page">

      {/* HERO SECTION */}

      <div className="registration-hero">

        <div className="registration-overlay"></div>

        <div className="container">

          <div className="registration-content">

            {/* BREADCRUMB */}

            <div className="registration-breadcrumb">

              <span>Home</span>

              <span>›</span>

              <span>Property</span>

              <span>›</span>

              <span className="active">
                Property Registration
              </span>

            </div>

            {/* TITLE */}

            <h1>
              Property Registration
              (Sale Deed Registration)
            </h1>

            {/* DESCRIPTION */}

            <p className="registration-desc">

              Get your Sale Deed Registered with the help
              of Expert Property Lawyers across India.

            </p>

            {/* SHOW MORE */}

            <div className="show-more-btn">

              Show More ↓

            </div>

            {/* RATING */}

            <div className="registration-rating">

              <div className="rating-left">

                <h3>4.8</h3>

                <span>(1116 Reviews)</span>

              </div>

              <div className="stars">

                ⭐ ⭐ ⭐ ⭐ ⭐

              </div>

            </div>

            {/* PURCHASE */}

            <p className="purchase-text">

              35,345 People Purchased

            </p>

            {/* BUTTONS */}

            <div className="registration-buttons">

              <button className="primary-btn">
                Get Started
              </button>

              <button className="secondary-btn">
                Chat Now
              </button>

            </div>

          </div>

        </div>

      </div>

      {/* WHAT IS PROPERTY REGISTRATION SECTION */}

<div className="property-info-section">

  <div className="container">

    <div className="property-info-left">

      <div className="last-update">
        Last Updated: Feb 13, 2024
      </div>

      <h2>
        What is Property Registration?
      </h2>

      <p>
        In India, property registration is mandatory to register all property
        transactions as per the provisions of the Registration Act, 1908.
        The transfer of immovable assets has to be recorded to obtain the
        rights of the property on the execution date of the deed.
      </p>

    </div>

  </div>

</div>


{/* HOW PROPERTY WORKS SECTION */}

<div className="property-how-section">

  <div className="container">

    <h2 className="property-how-title">
      How it works?
    </h2>

    <div className="property-how-grid">

      {/* CARD 1 */}

      <div className="property-how-card">

        <img
          src="https://cdn-icons-png.flaticon.com/512/2991/2991112.png"
          alt=""
        />

        <h3>
          Property document collection
        </h3>

        <p>
          All the property papers can be uploaded or hard copies can be collected.
        </p>

      </div>

      {/* CARD 2 */}

      <div className="property-how-card">

        <img
          src="https://cdn-icons-png.flaticon.com/512/1828/1828919.png"
          alt=""
        />

        <h3>
          Review & Analysis
        </h3>

        <p>
          Senior Property Lawyer will analyse and prepare detailed report.
        </p>

      </div>

      {/* CARD 3 */}

      <div className="property-how-card">

        <img
          src="https://cdn-icons-png.flaticon.com/512/2784/2784459.png"
          alt=""
        />

        <h3>
          Detailed consultation
        </h3>

        <p>
          Your consultation call with Senior property lawyer to discuss your property report.
        </p>

      </div>

      {/* CARD 4 */}

      <div className="property-how-card">

        <img
          src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
          alt=""
        />

        <h3>
          Delivery
        </h3>

        <p>
          Your detailed property verification report will be delivered in 5 days.
        </p>

      </div>

    </div>

  </div>

</div>


{/* PROPERTY DOCUMENTS SECTION */}

<div className="property-doc-section">

  <div className="container">

    {/* FIRST BLOCK */}

    <div className="property-doc-box">

      <h2>
        What all property documents do I need to register?
      </h2>

      <ol>

        <li>
          Estimation of the property value.
        </li>

        <li>
          Sale deed
        </li>

        <li>
          Payment of the stamp duty & registration charges.
        </li>

        <li>
          Approach the Sub-Registrar for registration.
        </li>

        <li>
          Documents submission.
        </li>

        <li>
          Other documents as per the local requirements.
        </li>

      </ol>

    </div>

    {/* SECOND BLOCK */}

    <div className="property-doc-box">

      <h2>
        What is the Procedure for property registration?
      </h2>

      <ul>

        <li>
          The property documents should be submitted to the office of the Sub-Registrar.
        </li>

        <li>
          Seller and purchaser must be present with two witnesses.
        </li>

        <li>
          Identity proofs like Aadhaar Card and PAN Card are required.
        </li>

        <li>
          If someone represents another person, power of attorney is needed.
        </li>

        <li>
          Company representatives need authority documents and board resolution.
        </li>

        <li>
          Property card and stamp duty payment proof must be submitted.
        </li>

        <li>
          Stamp duty varies from state to state in India.
        </li>

        <li>
          Women may get rebates or waivers on stamp duty payment.
        </li>

        <li>
          Witnesses also need ID proofs and biometric verification.
        </li>

      </ul>

    </div>

  </div>

</div>

{/* CHAT US SECTION */}

<div className="chat-us-section">

  <div className="container">

    <div className="chat-panel">

      {/* LEFT CONTENT */}

      <div className="chat-content">

        <h2>
          Chat with us
        </h2>

        <h3>
          Before you Buy your Property.
        </h3>

      </div>

      {/* RIGHT SIDE */}

      <div className="chat-right">

        <img
          src="https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1200&auto=format&fit=crop"
          alt="Chat Support"
        />

        <a
          href="https://api.whatsapp.com/send?phone=918743940556&text=Hello%20Team%20LegalAxis!"
          target="_blank"
          rel="noreferrer"
          className="chat-now-btn"
        >
          Chat Now
        </a>

      </div>

    </div>

  </div>

</div>

{/* OTHER PROPERTY PRODUCTS SECTION */}

<div className="other-property-products">

  <div className="container">

    <h2 className="other-product-title">
      Check out other Property Products
    </h2>

    <div className="other-product-grid">

      {/* CARD 1 */}

      <div className="other-product-card active-card">

        <h3>
          Property Report
        </h3>

        <ul>

          <li>
            Best drafting in India
          </li>

          <li>
            Faster Turn around Time
          </li>

          <li>
            Best price
          </li>

        </ul>

        <div className="other-product-footer">

          <div className="other-price">
            ₹ 5999
          </div>

          <a
            href="/property-sale-and-purchase/property-products/property-report"
            className="other-explore-btn"
          >
            Explore
          </a>

        </div>

      </div>



      {/* CARD 2 */}

      <div className="other-product-card">

        <h3>
          Sale Deed Drafting
        </h3>

        <ul>

          <li>
            Expert Property Lawyers
          </li>

          <li>
            Delivery within 48 Hours
          </li>

          <li>
            Legal consultation included
          </li>

        </ul>

        <div className="other-product-footer">

          <div className="other-price">
            ₹ 4999
          </div>

          <a href="/" className="other-explore-btn">
            Explore
          </a>

        </div>

      </div>



      {/* CARD 3 */}

      <div className="other-product-card">

        <h3>
          Property Registration
        </h3>

        <ul>

          <li>
            Hassle-free registration
          </li>

          <li>
            Dedicated support manager
          </li>

          <li>
            Doorstep document delivery
          </li>

        </ul>

        <div className="other-product-footer">

          <div className="other-price">
            ₹ 16999
          </div>

          <a href="/" className="other-explore-btn">
            Explore
          </a>

        </div>

      </div>



      {/* CARD 4 */}

      <div className="other-product-card">

        <h3>
          Property Paper Review
        </h3>

        <ul>

          <li>
            Senior lawyer consultation
          </li>

          <li>
            Detailed legal review
          </li>

          <li>
            Complete document clarity
          </li>

        </ul>

        <div className="other-product-footer">

          <div className="other-price">
            ₹ 4449
          </div>

          <a href="/" className="other-explore-btn">
            Explore
          </a>

        </div>

      </div>

    </div>

  </div>

</div>



{/* VIRTUAL SECTION */}

<div className="virtual-section">

  <div className="container">

    <h2>
      All property legal solutions under one roof
    </h2>

    <p>
      With more than 35000 verified properties
      LegalAxis offers most Reliable property legal service
    </p>

  </div>

</div>



{/* ONLINE SECTION */}

<div className="online-section">

  <div className="container">

    <div className="online-grid">

      {/* BOX 1 */}

      <div className="online-card">

        <img
          src="https://cdn-icons-png.flaticon.com/512/684/684908.png"
          alt=""
        />

        <h3>
          35K+ Properties
        </h3>

        <p>
          With more than 35000 verified properties
          LegalAxis offers most Reliable property legal service
        </p>

      </div>



      {/* BOX 2 */}

      <div className="online-card">

        <img
          src="https://cdn-icons-png.flaticon.com/512/3135/3135706.png"
          alt=""
        />

        <h3>
          All in One Solution
        </h3>

        <p>
          Property verification, legal drafting for property,
          Property registration everything under one roof.
        </p>

      </div>



      {/* BOX 3 */}

      <div className="online-card">

        <img
          src="https://cdn-icons-png.flaticon.com/512/854/854878.png"
          alt=""
        />

        <h3>
          Trusted in 80 Countries
        </h3>

        <p>
          Indians around the globe in more than
          80 countries trust LegalAxis for their
          property related matters.
        </p>

      </div>

    </div>

  </div>

</div>

    </div>

  );

}

export default PropertyRegistration;